<template>
    <div
        id="itb-account-box"
        class="card itb-top-tail"
        @mouseover="displayWindow"
        @mouseleave="closeWindow"
        v-show="closeButtonUnpressed && (isOpen || showWindowDialog)"
    >
        <button class="itb-mdi-logo" @click="toggleIcon">
            <img
                src="/images/times-solid.svg"
                alt="close"
                class="itb-icon itb-paperplane"
            />
        </button>
        <div
            v-if="appParams && appParams.staticTranslations"
            class="itb-account-body"
        >
            <h3>
                {{ appParams.staticTranslations["title.your_account"] }}
            </h3>
            <p class="text-center itb-company-name mb-0 pl-2">
                {{ profile.bill_company }}
            </p>
            <div
                class="d-flex justify-content-center align-items-center itb-representative-info mb-2 mt-2"
            >
                <img src="/images/icons/account-outline.svg" alt="close" />
                <p class="text-center itb-company-name px-0 mb-0">
                    {{ profile.name }}
                </p>
            </div>

            <p class="itb-account-discount" v-if="discountValue">
                {{ appParams.staticTranslations["general.account_discount"] }}:
                {{ discountValue }}&percnt;
            </p>
            <div class="itb-account-links">
                <p @click="openAddresses">
                    <img
                        src="/images/cogs-solid.svg"
                        :alt="appParams.staticTranslations['general.settings']"
                    />{{ appParams.staticTranslations["general.settings"] }}
                </p>
                <p @click="openCarts">
                    <img
                        src="/images/cart-arrow-down-solid.svg"
                        :alt="appParams.staticTranslations['carts.your_carts']"
                    />{{ appParams.staticTranslations["carts.your_carts"] }}
                </p>
                <p hidden>
                    <img
                        src="/images/heart-solid.svg"
                        :alt="appParams.staticTranslations['general.favorites']"
                    />{{ appParams.staticTranslations["general.favorites"] }}
                </p>
                <p @click="logout">
                    <img
                        src="/images/sign-out-alt-solid.svg"
                        :alt="appParams.staticTranslations['title.logout']"
                    />{{ appParams.staticTranslations["title.logout"] }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Jwt from "jsonwebtoken";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "AccountInformation",
    props: {
        visible: Boolean,
    },
    data() {
        return {
            showWindowDialog: false,
            closeButtonUnpressed: true,
            discountValue: 0,
            pohodaPriceName: "",
        };
    },
    computed: {
        ...mapGetters({
            isLoggedIn: "getClientLogged",
            profile: "getClientProfile",
            appParams: "getAppParams",
        }),
        isOpen: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    created() {
        this.getDiscount();
    },

    methods: {
        toggleIcon() {
            this.closeButtonUnpressed = false;
            this.showWindowDialog = false;
            this.$emit("toggleStatic");
            this.$emit("close");
            setTimeout(() => {
                this.closeButtonUnpressed = true;
            }, 500);
        },
        openAddresses() {
            if (this.$route.path != "/settings") {
                this.$router.push("/settings");
            }
            this.isOpen = !this.isOpen;
            this.$emit("closeNavbar");
            this.toggleIcon();
        },
        openCarts() {
            if (this.$route.path != "/saved-carts") {
                this.$router.push("/saved-carts");
            }
            this.isOpen = !this.isOpen;
            this.$emit("closeNavbar");
            this.toggleIcon();
        },
        logout() {
            axios
                .get("/api/auth/client-logout", {
                    headers: {
                        Authorization:
                            "Bearer " +
                            this.$store.state.tokenData.client.access_token,
                    },
                })
                .then(() => {
                    localStorage.removeItem("itb-spa-token-client");
                    this.$store.dispatch("resetState");

                    if (this.$route.path != "/") {
                        this.$router.push("/");
                    }
                });
            this.isOpen = !this.isOpen;
            this.$emit("closeNavbar");
            this.toggleIcon();
        },

        displayWindow() {
            this.showWindowDialog = true;
        },
        closeWindow() {
            this.showWindowDialog = false;
        },
        getDiscount() {
            axios
                .post("/getDiscount", { client_id: this.profile.id })
                .then((response) => {
                    this.pohodaPriceName = response.data.pohodaPriceName;
                    this.discountValue = response.data.discount;

                    if (this.pohodaPriceName) {
                        // this.discountValue = 0;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
